import { render, staticRenderFns } from "./msgrIcon.vue?vue&type=template&id=5a23ead6&"
import script from "./msgrIcon.vue?vue&type=script&lang=ts&"
export * from "./msgrIcon.vue?vue&type=script&lang=ts&"
import style0 from "./msgrIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports